/**
 * Creates an object from url query parameters
 *
 * Ex:
 * https://spilnu.dk/?txId=1026240609&psp=PaymentIQ&transactionType=deposit
 *
 * Will return:
 * {
 *     txId: '1026240609',
 *     psp: 'PaymentIQ',
 *     transactionType: 'deposit'
 * }
 */

import { getQuery } from 'ufo'

export default function getObjectFromUrlParams<TParams extends Record<string, any> = Record<string, any>>(url: string = ''): TParams {
    if (!url.length) return {} as TParams

    return getQuery(url)
}
